import { HISTORICAL_STATUSES } from "../../types/onboarding";
import LeadsView from "../OnboardingCustomers/LeadsView";

export default function HistoricalCustomers() {
  return (
    <LeadsView
      endpoint="/api/admin/operations/historical"
      title="Historical customers"
      subtitle="Pólizas completadas o canceladas — click en una fila para ver todos los datos."
      availableStatuses={HISTORICAL_STATUSES}
      defaultStatuses={HISTORICAL_STATUSES}
    />
  );
}
